import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcessSaveAutoZustellungParamStatus: 'idle',
    startProcessSaveAutoZustellungParamError: undefined as any,
    loadUserParamsProcessSaveAutoZustellungParamStatus: 'idle',
    loadUserParamsProcessSaveAutoZustellungParamError: undefined as any,

    processSaveAutoZustellungParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcessSaveAutoZustellungParam = createAsyncThunk('processSaveAutoZustellungParamSlice/startProcessSaveAutoZustellungParam', async ({ processSaveAutoZustellungParam }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcessSaveAutoZustellungParam/`,
        prepareData(processSaveAutoZustellungParam),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcessSaveAutoZustellungParamStatus } = getState().processSaveAutoZustellungParamSlice
        return startProcessSaveAutoZustellungParamStatus !== 'pending'
    }
})

export const loadUserParamsProcessSaveAutoZustellungParam = createAsyncThunk('processSaveAutoZustellungParamSlice/loadUserParamsProcessSaveAutoZustellungParam', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcessSaveAutoZustellungParam/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcessSaveAutoZustellungParamStatus } = getState().processSaveAutoZustellungParamSlice
        return loadUserParamsProcessSaveAutoZustellungParamStatus !== 'pending'
    }
})

const ProcessSaveAutoZustellungParamSlice = createSlice({
    name: 'processSaveAutoZustellungParamSlice',
    initialState,
    reducers: {
        resetstartProcessSaveAutoZustellungParam: (state) => {
            state.job = undefined
            state.startProcessSaveAutoZustellungParamError = undefined
        },
        resetstartProcessSaveAutoZustellungParamError: (state) => {
            state.startProcessSaveAutoZustellungParamError = undefined
        },
        resetloadUserParamsProcessSaveAutoZustellungParam: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcessSaveAutoZustellungParamError = undefined
        },
        resetloadUserParamsProcessSaveAutoZustellungParamError: (state) => {
            state.loadUserParamsProcessSaveAutoZustellungParamError = undefined
        },
        removeFromProcessSaveAutoZustellungParamListById: (state, action) => {
            state.processSaveAutoZustellungParamList = state.processSaveAutoZustellungParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcessSaveAutoZustellungParamListByIds: (state, action) => {
            state.processSaveAutoZustellungParamList = state.processSaveAutoZustellungParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.processSaveAutoZustellungParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcessSaveAutoZustellungParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.processSaveAutoZustellungParamList = []
            state.startProcessSaveAutoZustellungParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcessSaveAutoZustellungParam.pending, (state) => {
            state.startProcessSaveAutoZustellungParamStatus = 'pending'
            state.startProcessSaveAutoZustellungParamError = undefined
        })
        builder.addCase(startProcessSaveAutoZustellungParam.fulfilled, (state, action) => {
            state.startProcessSaveAutoZustellungParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcessSaveAutoZustellungParam.rejected, (state, action) => {
            state.startProcessSaveAutoZustellungParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcessSaveAutoZustellungParamError = action.error.message
            } else {
                state.startProcessSaveAutoZustellungParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcessSaveAutoZustellungParam.pending, (state) => {
            state.loadUserParamsProcessSaveAutoZustellungParamStatus = 'pending'
            state.loadUserParamsProcessSaveAutoZustellungParamError = undefined
        })
        builder.addCase(loadUserParamsProcessSaveAutoZustellungParam.fulfilled, (state, action) => {
            state.loadUserParamsProcessSaveAutoZustellungParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcessSaveAutoZustellungParam.rejected, (state, action) => {
            state.loadUserParamsProcessSaveAutoZustellungParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcessSaveAutoZustellungParamError = action.error.message
            } else {
                state.loadUserParamsProcessSaveAutoZustellungParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcessSaveAutoZustellungParam,
    resetstartProcessSaveAutoZustellungParamError,
    resetloadUserParamsProcessSaveAutoZustellungParam,
    resetloadUserParamsProcessSaveAutoZustellungParamError,
    removeFromProcessSaveAutoZustellungParamListById,
    removeFromProcessSaveAutoZustellungParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ProcessSaveAutoZustellungParamSlice.actions
export default ProcessSaveAutoZustellungParamSlice.reducer
